import SchdType from '../pages/Reserve/SchdType'
import SchdTime from '../pages/Reserve/SchdTime'
import InformationForm from '../pages/InformationForm/InformationForm'
import Result from '../pages/Result/Result'
import Search from '../pages/ReserveHistory/Search'
import HistoryResult from '../pages/ReserveHistory/HistoryResult'

const reserveRoutes=[
    {
        path:"/first_step",
        name:"了解篩檢資格",
        component: SchdType
    },
    {
        path:"/second_step",
        name:"選擇項目與預約時段",
        component: SchdTime
    },
    {
        path:"/third_step",
        name:"填寫基本資料",
        component: InformationForm
    },
    {
        path:"/result",
        name:"預約完成",
        component: Result
    },
    // {
    //     path:"/second_step",
    //     name:"選擇預約時間",
    //     component: Reserve
    // },
    // {
    //     path:"/third_step",
    //     name:"簡訊驗證",
    //     component: Reserve
    // },
    // {
    //     path:"/fourth_step",
    //     name:"填寫基本資料",
    //     component: Reserve
    // },
    // {
    //     path:"/fifth_step",
    //     name:"預約完成",
    //     component: Reserve
    // }
]     

const reserveHistoryRoute = [
    {
        path:"/search",
        name:"查詢預約紀錄",
        component: Search
    },
    {
        path:"/historyResult",
        name:"查詢預約紀錄結果",
        component: HistoryResult
    },
]

export {
    reserveRoutes,
    reserveHistoryRoute
}